var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displaySuccess)?_c('Modal',{attrs:{"config":_vm.modalConfig.confirmAddPayee},on:{"btn2Action":function($event){return _vm.$emit('closePayeeSuccess')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }